import { createFileRoute } from "@tanstack/react-router";

import {
  requireSubscriptionManagement,
  requireSubscriptionOwner,
} from "@/lib/subscription-management";

export const Route = createFileRoute("/_auth/_app-shell/billing/")({
  beforeLoad: async ({ context }) => {
    requireSubscriptionOwner(context.queryClient);
    await requireSubscriptionManagement();
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <h1>Billing</h1>;
}
